import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '1.125rem',
    marginRight: 'calc(-1.125rem + 0.5rem)',
    height: '100%',
    padding: '0',
    [theme.breakpoints.down('md')]: {
      marginLeft: '0.5rem',
      marginRight: '0'
    }
  },

  icon: {
    zIndex: 10,
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    height: '100%',
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer'
  }
}))

export default useStyles
